import './functions.js';

import Vue from 'vue';
import store from './store/index';
import vuetify from './vuetify';

import VModalContact from './components/main/modal_contact.vue';
import VModalContents from './components/main/modal_contents.vue';
import VCarousel from './components/main/carousel.vue';
import VCarouselClients from './components/main/carousel_clients.vue';
import VFormUpload from './components/main/form_upload.vue';
import VFormContact from './components/main/form_contact.vue';
import VAppeal from './components/main/appeal.vue';
import VBusinessTabs from './components/main/businesstabs.vue';
import VCatalogFilter from './components/main/catalog_filter.vue';
import VApplicationForm from './components/main/application_form.vue';
import VAccordion from './components/main/accordion.vue';
import VCarouselItems from './components/main/carousel_items.vue';

import VDialogCall from './components/main/contact__Call.vue';
import VDialogMail from './components/main/contact__Mail.vue';
import VDialogRezume from './components/main/contact__Rezume.vue';
import VSearchNearest from './components/main/search_nearest_office.vue';
import VBidForm from './components/main/bid_form.vue';
import VRegEvents from './components/main/form_reg_events.vue';

import VManageRegistration from './components/main/manage-registration.vue';
import VDocuments from './components/main/documents.vue'

import NotFoundPage from "./components/main/NotFoundPage.vue";
import VFormCooperation from "./components/main/form_cooperation.vue";
import VOrderSamplesForm from "./components/main/orderSamples_form.vue";
import VFormAnticorruption from "./components/main/form_anticorruption.vue";
import VPersistentBottom from './components/main/persistent_bottom.vue';
import expansionPanel from "./components/main/expansion.vue";
import VPool from "./components/main/poll.vue";
import VTest from "./components/main/test.vue"; // для тестирования новых модулей
import FormCareerNew from "./components/main/form_career_new.vue";
import formContract from "./components/main/form_contract.vue";
import packageType from "./components/main/package_type.vue";
import opinionPolls from "./components/main/opinion_polls.vue";
import chemicalPolls from "./components/main/chemical_polls.vue";





// import testCard from "./components/main/test_card.vue";
import distribut from "./components/main/distribut.vue";
import VFormNew from "./components/main/form_new.vue";
import VFormNewMain from "./components/main/form_new_main.vue";

//MANAGER
import AddScopeApplication from './components/main/manager/add-scope-of-application.vue'
import EditScopeApplication from './components/main/manager/edit-scope-of-application.vue'


import VPollsNew from './components/main/pollsNew.vue'


// import noindex from "./components/main/noindex.vue";

import VueAgile from 'vue-agile';

import vuescroll from 'vuescroll';

// новые компоненты

import banner from "./components/main/banner.vue"
import businessAreasNew from "./components/main/business_areas_new.vue";
import history from "./components/main/history.vue";
import enterpriseMap from "./components/main/enterpriseMap.vue"
import VSuccessStories from "./components/main/success_stories.vue";
import enterpriseDetail from "./components/main/enterpriseDetail.vue";
import industries from "./components/main/industries.vue";
import VKeyVacancies from "./components/main/key_vacancies.vue"
import recommend from "./components/main/recommend.vue";
import VTabDetail from "./components/main/tab_detail.vue";
import VOtherTypes from "./components/main/other_types.vue";
import expansionCustom from "./components/main/expansionCustom.vue";
import exspansionDocs from "./components/main/exspansion_docs.vue";
import contactUsForm from './components/main/contact_us_form.vue'
import tapesExpansion from "./components/main/tapes_expansion.vue";
import formOrderTapes from "./components/main/form_order_tapes.vue"
import tapesTabs from "./components/main/tapes_tabs.vue";
import vacancyMain from "./components/main/vacancy_main.vue";
import vacancyDetails from "./components/main/vacancy_details.vue";
import vacancyPage from "./components/main/vacancy_page.vue";
import vacancyForm from "./components/main/vacancy_form.vue";
import packagingSearch from "./components/main/packaging_search.vue";
import traysTypes from "./components/main/trays_types.vue";


// forms_konteyner_polimernyy формы
import FormKonteynerPolimernyyFooter from "./components/main/forms_konteyner_polimernyy/form_konteyner_polimernyy_footer.vue";
import FormKonteynerPolimernyyRequestTrays from "./components/main/forms_konteyner_polimernyy/form_konteyner_polimernyy_request_trays.vue";
import FormKonteynerPolimernyyRequestPackaging from "./components/main/forms_konteyner_polimernyy/form_konteyner_polimernyy_request_packaging.vue";

Vue.use(vuescroll);

Vue.use(VueAgile);

import './theme/index.scss';


var vm = new Vue({
    components: {
        VModalContact,
        VCarousel,
        VCarouselClients,
        VFormUpload,
        VAppeal,
        VFormContact,
        VModalContents,
        VBusinessTabs,
        VCatalogFilter,
        VApplicationForm,
        VAccordion,
        VCarouselItems,
        VDialogCall,
        VDialogMail,
        VDialogRezume,
        VSearchNearest,
        VBidForm,
        VRegEvents,
        VManageRegistration,
        VDocuments,
        NotFoundPage,
        VFormCooperation,
        VOrderSamplesForm,
        VFormAnticorruption,
        VPersistentBottom,
        expansionPanel,
        VPool,
        VTest,
        FormCareerNew,
        formContract,
        packageType,
        distribut,

        //MANAGER
        AddScopeApplication,
        EditScopeApplication,
        VPollsNew,
        VFormNew,
        VFormNewMain,

        // новые
        banner,
        businessAreasNew,
        history,
        enterpriseMap,

        VSuccessStories,
        enterpriseDetail,
        industries,
        VKeyVacancies,
        recommend,
        VTabDetail,
        VOtherTypes,

        expansionCustom,
        exspansionDocs,
        contactUsForm,
        tapesExpansion,
        formOrderTapes,
        tapesTabs,

        vacancyDetails,
        vacancyPage,
        vacancyForm,
        vacancyMain,
        packagingSearch,
        traysTypes,

        opinionPolls,
        chemicalPolls,

        // forms_konteyner_polimernyy формы
        FormKonteynerPolimernyyFooter,
        FormKonteynerPolimernyyRequestTrays,
        FormKonteynerPolimernyyRequestPackaging

        // noindex
    },
    data() {
        return {}
    },
    computed: {},
    // i18n,
    vuetify,
    store,
    methods: {
        redirect(url) {
            window.location.href = url;
        }
    },

}).$mount('#app');

//main-load